// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
}
ion-header ion-toolbar div.date {
  margin-right: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(150, 147, 147);
}
ion-header ion-toolbar div.date ion-icon {
  margin-right: 8px;
}
ion-header ion-toolbar div.date p {
  margin: 0;
  text-wrap: nowrap;
  font-size: 14px;
}
ion-header ion-toolbar div.operator {
  display: flex;
  align-items: center;
  justify-content: end;
  cursor: pointer;
}
ion-header ion-toolbar div.operator span {
  font-size: 14px;
}
ion-header ion-toolbar div.operator a.workers {
  color: rgb(150, 147, 147);
  font-weight: 500;
}

.app-version-footer {
  position: fixed;
  bottom: -2px;
  right: 0px;
  padding: 0 10px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  z-index: 9999;
  font-weight: bold;
  font-size: 15px;
  color: #444;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAAR;AAEQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBAAA;AADZ;AAGY;EACI,iBAAA;AADhB;AAIY;EACI,SAAA;EACA,iBAAA;EACA,eAAA;AAFhB;AAMQ;EAGI,aAAA;EACA,mBAAA;EACA,oBAAA;EAGA,eAAA;AARZ;AAUY;EACI,eAAA;AARhB;AAWY;EACI,yBAAA;EACA,gBAAA;AAThB;;AAmBA;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAhBJ","sourcesContent":["ion-header {\r\n    ion-toolbar {\r\n        height: 80px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        padding: 0 30px;\r\n\r\n        div.date {\r\n            margin-right: 32px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            color: rgb(150, 147, 147);\r\n\r\n            ion-icon {\r\n                margin-right: 8px;\r\n            }\r\n\r\n            p {\r\n                margin: 0;\r\n                text-wrap: nowrap;\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        div.operator {\r\n\r\n\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: end;\r\n            // border-bottom: 1px solid rgb(150, 147, 147);\r\n\r\n            cursor: pointer;\r\n\r\n            span {\r\n                font-size: 14px;\r\n            }\r\n\r\n            a.workers {\r\n                color: rgb(150, 147, 147);\r\n                font-weight: 500;\r\n\r\n                // color: rgb(150, 147, 147);\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}\r\n\r\n.app-version-footer {\r\n    position: fixed;\r\n    bottom: -2px;\r\n    right: 0px;\r\n    padding: 0 10px;\r\n    background-color: rgba(0, 0, 0, 0.15);\r\n    border-radius: 5px;\r\n    z-index: 9999;\r\n    font-weight: bold;\r\n    font-size: 15px;\r\n    color: #444;\r\n    pointer-events: none;\r\n    user-select: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
